import React from 'react'
import { AppContainer, AppLogo } from 'components/layout'
import { Animation, Icon } from 'components/library'
import { AppContext } from 'helpers'
import './AppHeader.css'

const AppHeader = props => (
  <div className="App-header">
    <Animation name="slideInDown">
      <AppContainer>
        <div className="App-header-top">
          <div className="App-header-left">
            <AppLogo />
          </div>
          <div className="App-header-right">
            <AppContext.Consumer>
              {({ toggleNavigation }) => (
                <div className="App-navigation">
                  <a onClick={() => toggleNavigation()}><Icon name="menu" size="large" /></a>
                </div>
              )}
            </AppContext.Consumer>
          </div>
        </div>
      </AppContainer>
    </Animation>
  </div>
)

export default AppHeader


// WEBPACK FOOTER //
// ./src/components/layout/header/AppHeader.js